import { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faBan,
//   faCheckCircle,
//   faSignInAlt,
//   faTrashAlt,
// } from "@fortawesome/free-solid-svg-icons";
// import { Table, Button, Badge } from "reactstrap";
// import TableHeader from "../../common/tableHeader";
// import TableLoader from "../../common/tableLoader";
import {
    CheckOutlined,
    DeleteOutlined,
    LoginOutlined,
    StopOutlined,
    UserOutlined,
} from "@ant-design/icons";
import { message } from "antd";

import CommonTable from "../../../global/table"
import CommonCardView from "../../../global/cardView"
import CommonDrawer from "../../../global/drawer"
import CommonDialog from "../../../global/dialog"
import NoRecordFound from "../../../global/noRecordFound"
import SOURCES from "../../../../utils/constants";
import { MSG_USER } from "../../../../utils/message";
import EnhanceUserDetails from "./enhance-users-details";
import EnhanceUserCardView from "./enhance-user-card-view";

const EnhancedUserList = ({
    isLoading,
    userList,
    setshowDeatail,
    showDetail,
    setLeadDetail,
    getUsers,
    getSearchData,
    searchInput,
    accountStatus,
    loginAsUser,
    deleteUser,
    deleteId,
    removeSuccess,
    setDeleteId,
    setSortBy,
    sortBy,
    setSortOrder,
    sortOrder,
    testAccount = false,
    handleRemoveTestAccount = null,
    usersViewType,
    paymentPlans,
    setUserInfo,
    userInfo,
    processSuccess,
    onMutationSuccess,
}) => {
    const [toggleModal, setToggleModal] = useState({
        show: false,
        type: "",
    });
    const [isConfirmButtonLoading, setIsConfirmButtonLoading] = useState(false);
    const [userDetails, setUserDetails] = useState({
        show: false,
        data: null,
        email: "",
    });

    useEffect(() => {
        if (!processSuccess) return;
        setToggleModal({ show: false, type: "", email: "" });
    }, [processSuccess]);

    useEffect(() => {
        if (!removeSuccess) return;
        setToggleModal({ show: false, type: "", email: "" });
        if (setDeleteId) setDeleteId(null);
    }, [removeSuccess, setDeleteId]);

    // useEffect(() => {
    //   if (removeSuccess) {
    //     setToggleModal({
    //       show: false,
    //       type: "",
    //     });
    //     console.log("useEffect called in userlist");
    //     getUsers();
    //     setDeleteId(null);
    //   }
    // }, [removeSuccess]);

    const showHideDetail = (data) => {
        // setshowDeatail(!showDetail);
        // setLeadDetail(data);
        setUserDetails({
            show: true,
            data,
        });
    };

    // const changeUserStatus = async (email, userStatus) => {
    //   await accountStatus({ email, userStatus }, MSG_USER.UPDATE);
    //   if (searchInput) await getSearchData();
    //   else await getUsers();
    // };

    // const sortData = (title) => {
    //   setSortBy(title);
    //   setSortOrder(sortOrder === 1 ? -1 : 1);
    // };

    // Updated columns configuration
    const columns = [
        {
            title: "Name",
            dataIndex: "name",
            key: "name",
            render: (text, record) => (
                <p className="text-black cursor-pointer">{text}</p>
            ),
            sorter: true,
            sortOrder:
                sortBy === "name" ? (sortOrder === 1 ? "ascend" : "descend") : null,
            isAvatar: true,
        },
        {
            title: "Email",
            dataIndex: "email",
            key: "email",
            sorter: true,
            sortOrder:
                sortBy === "email" ? (sortOrder === 1 ? "ascend" : "descend") : null,
        },
        {
            title: "Phone",
            dataIndex: "phone",
            key: "phone",
        },
        {
            title: "Company",
            key: "company",
            dataIndex: "company",
            sorter: true,
            sortOrder:
                sortBy === "company" ? (sortOrder === 1 ? "ascend" : "descend") : null,
        },
        {
            title: "Verified",
            key: "verified",
            dataIndex: "verified",
            isBadge: true,
            // The badge config will come from data (verifiedBadge)
        },
        {
            title: "Plan",
            key: "plan",
            dataIndex: "plan",
            sorter: true,
            sortOrder:
                sortBy === "plan" ? (sortOrder === 1 ? "ascend" : "descend") : null,
            isBadge: true,
            badgeType: "primary", // Default badge type
        },
        {
            title: "Trial",
            key: "trial",
            dataIndex: "trial",
            isBadge: true,
            // The badge config will come from data (trialBadge)
        },
        {
            title: "Status",
            key: "status",
            dataIndex: "status",
            isBadge: true,
            badgeType: "success", // Default badge type
        },
    ];

    // Updated data mapping
    const data =
        Array.isArray(userList) && userList?.length > 0
            ? userList?.map((item) => {
                return {
                    ...item,
                    key: item._id,
                    id: item._id, // Add id for rowKey
                    name: item.name,
                    email: item.email,
                    phone: item.phone,
                    company: item.company,
                    // onClick: () => setUserDetails({ show: true, data: item }),
                    // Verified field and badge configuration
                    verified: item.verified === "y" ? "Verified" : "Not Verified",
                    verifiedBadge:
                        item.verified === "y"
                            ? { text: "Verified", color: "success" }
                            : { text: "Not Verified", color: "danger" },

                    // Plan field
                    plan:
                        item?.PlanInformation?.planName ||
                        item?.PlanInformation[0]?.planName,
                    // planBadge is optional - will use default badgeType from column

                    // Trial field and badge configuration
                    trial: item.isTrial === "y" ? "Yes" : "No",
                    trialBadge:
                        item.isTrial === "y"
                            ? { text: "Yes", color: "danger" }
                            : { text: "No", color: "success" },

                    // Status field and badge configuration
                    status: item.userStatus,
                    statusBadge:
                        item.userStatus === "active"
                            ? { text: "Active", color: "success" }
                            : { text: "Suspended", color: "danger" },

                    // Your important conditional logic preserved
                    canLogin:
                        item.userRole !== SOURCES.USER_ROLE_ADMIN &&
                        item.verified === "y",

                    statusAction:
                        item.userRole !== SOURCES.USER_ROLE_ADMIN && item.verified === "y"
                            ? item.userStatus === "active"
                                ? { action: "suspend", color: "secondary" }
                                : { action: "activate", color: "primary" }
                            : null,

                    deleteAction: testAccount
                        ? { action: "remove", color: "danger" }
                        : item.userRole !== SOURCES.USER_ROLE_ADMIN &&
                            item.verified === "n"
                            ? { action: "delete", color: "danger" }
                            : null,
                };
            })
            : [];

    const actions = [
        /*
      ───────────────────────────────────────────────
       ✅ 1) LOGIN BUTTON
         Show only when:
          ✔ userRole !== admin
          ✔ verified === "y"
      ───────────────────────────────────────────────
      */
        {
            label: "Login As User",
            icon: <LoginOutlined />,
            condition: (record) =>
                record.userRole !== SOURCES.USER_ROLE_ADMIN &&
                record.verified === "Verified", // mapped from old: verified === "y"
            onClick: (record) => loginAsUser(record.email),
            className:
                "!text-primary !border-primary hover:!border-primary hover:!bg-primary hover:!text-white",
        },

        /*
      ───────────────────────────────────────────────
       ✅ 2) ACTIVATE / SUSPEND BUTTON
         Show only when:
          ✔ userRole !== admin
          ✔ verified === "y"
         If userStatus === active → show SUSPEND
         Else → show ACTIVATE
      ───────────────────────────────────────────────
      */
        {
            label: "Activate",
            icon: <CheckOutlined />,
            condition: (record) =>
                record.userRole !== SOURCES.USER_ROLE_ADMIN &&
                record.verified === "Verified",
            transform: (record, action) => {
                if (record.status === "active") {
                    return {
                        ...action,
                        label: "Suspend",
                        icon: <StopOutlined />,
                        className:
                            "!text-orange-500 !border-orange-500 hover:!border-orange-500 hover:!bg-orange-500 hover:!text-white",
                    };
                }
                return {
                    ...action,
                    className:
                        "!text-black !border-black hover:!border-black hover:!bg-black hover:!text-white",
                };
            },
            onClick: (record) => {
                if (record.status === "active") {
                    setToggleModal({
                        show: true,
                        type: "suspend",
                        email: record.email,
                    });
                } else {
                    setToggleModal({
                        show: true,
                        type: "activate",
                        email: record.email,
                    });
                }
            },
        },

        /*
      ───────────────────────────────────────────────
       ✅ 3) DELETE / REMOVE FROM TEST
         If testAccount → show “Remove From Test”
            → always visible
    
         Else → show Delete only when:
            ✔ userRole !== admin
            ✔ verified === "n"
      ───────────────────────────────────────────────
      */
        {
            label: testAccount ? "Remove From Test" : "Delete",
            icon: <DeleteOutlined />,
            condition: (record) => {
                if (testAccount) return true;
                return (
                    record.userRole !== SOURCES.USER_ROLE_ADMIN &&
                    record.verified === "Not Verified" // original: verified === "n"
                );
            },
            className:
                "border !border-red-500 !text-red-500 hover:!bg-red-500 hover:!text-white border-none hover:!border-none",
            onClick: (record) => {
                if (testAccount) {
                    handleRemoveTestAccount(record.id);
                } else {
                    setDeleteId(record.id);
                    setToggleModal({ show: true, type: "delete" });
                }
            },
        },
    ];

    const getInitials = (name) => {
        if (!name) return "U";
        const parts = name.trim().split(" ");
        if (parts.length === 1) {
            return parts[0].charAt(0).toUpperCase();
        }
        const firstInitial = parts[0].charAt(0).toUpperCase();
        const lastInitial = parts[parts.length - 1].charAt(0).toUpperCase();
        return `${firstInitial}${lastInitial}`;
    };

    const getBadgeColor = (badgeData) => {
        if (!badgeData) return "default";
        const colorMap = {
            success: "success",
            danger: "error",
            primary: "processing",
            warning: "warning",
        };
        return colorMap[badgeData.color] || "default";
    };

    const onActionConfirm = async (actionType) => {
        try {
            setIsConfirmButtonLoading(true);
            if (actionType === "delete") {
                await deleteUser(deleteId);
                onMutationSuccess?.();
            } else if (actionType === "activate") {
                await accountStatus(
                    { email: toggleModal.email, userStatus: SOURCES.USER_STATUS_ACTIVE },
                    MSG_USER.UPDATE
                );
                onMutationSuccess?.();
            } else if (actionType === "suspend") {
                await accountStatus(
                    {
                        email: toggleModal.email,
                        userStatus: SOURCES.USER_STATUS_SUSPENDED,
                    },
                    MSG_USER.UPDATE
                );
                onMutationSuccess?.();
            }
            setToggleModal({ show: false, type: "", email: "" });
        } catch (error) {
            message.error(
                actionType === "delete"
                    ? "Failed to delete user"
                    : "Failed to update user status"
            );
        } finally {
            setIsConfirmButtonLoading(false);
        }
    };

    return (
        <>
            {Array.isArray(userList) && userList?.length > 0 ? (
                <>
                    {usersViewType === "LIST" ? (
                        <CommonTable
                            columns={columns}
                            data={data}
                            showActions={true}
                            actions={actions}
                            getInitials={getInitials}
                            onRowClick={(record) =>
                                setUserDetails({
                                    show: true,
                                    data: record,
                                })
                            }
                        />
                    ) : (
                        <CommonCardView className={""}>
                            {data.map((record, index) => (
                                <EnhanceUserCardView
                                    key={record.id || index}
                                    record={record}
                                    actions={actions}
                                    testAccount={testAccount}
                                    SOURCES={SOURCES}
                                    getInitials={getInitials}
                                    onCardClick={() =>
                                        setUserDetails({ show: true, data: record })
                                    }
                                />
                            ))}
                        </CommonCardView>
                    )}
                </>
            ) : (
                <NoRecordFound message="No users found." />
            )}

            {toggleModal && (
                <CommonDialog
                    title={
                        toggleModal.type === "delete"
                            ? "Delete User"
                            : toggleModal.type === "activate"
                                ? "Activate User"
                                : "Suspend User"
                    }
                    description={
                        toggleModal.type === "delete"
                            ? "Are you sure you want to delete User?"
                            : toggleModal.type === "activate"
                                ? "Are you sure you want to activate User?"
                                : "Are you sure you want to suspend User?"
                    }
                    open={toggleModal.show}
                    setOpen={() => setToggleModal({ show: false, type: "" })}
                    onOk={() => onActionConfirm(toggleModal.type)}
                    onCancel={() => setToggleModal({ show: false, type: "" })}
                    isConfirmButtonLoading={isConfirmButtonLoading}
                />
            )}

            {userDetails.show && (
                <CommonDrawer
                    open={userDetails.show}
                    setOpen={() => setUserDetails({ show: false, data: null })}
                    title="User Details"
                    width={"65%"}
                    extra={null}
                    children={
                        <EnhanceUserDetails
                            leadDetail={userDetails.data}
                            userInfo={userInfo}
                            paymentPlans={paymentPlans}
                            loginAsUser={loginAsUser}
                            deleteUser={deleteUser}
                            removeSuccess={removeSuccess}
                            getUsers={getUsers}
                            setshowDeatail={setshowDeatail}
                            getBadgeColor={getBadgeColor}
                            setUserInfo={setUserInfo}
                        />
                    }
                    isSubmitBtn={{
                        show: true,
                        label: "Login As User",
                        loading: false,
                    }}
                    onSubmit={() => loginAsUser(userDetails.data.email)}
                />
            )}
        </>
    );
};
export default EnhancedUserList;
